export default __webpack_public_path__ + "static/donations-logo-dba1fbbf3ac1d5b9c918d94208457f2a.png";